import React, { useEffect, useState } from "react";
import { Dropdown } from 'react-bootstrap';
import { changeLayoutMode } from 'slices/thunk';
import { useDispatch } from 'react-redux';
import { LAYOUT_MODE_TYPES } from 'Common/constants/layout';
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { resolveColorMode } from "utils/colorMode";


const LayoutModeDropdown = () => {
    const dispatch = useDispatch<any>();
    const {t} = useTranslation();
    const layoutMode = useSelector((state: any) => state.Layout.layoutModeType);
    const [resolvedMode, setResolvedMode] = useState(() => resolveColorMode(layoutMode));

    useEffect(() => {
        const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");
        const syncResolvedMode = () => setResolvedMode(resolveColorMode(layoutMode));

        syncResolvedMode();
        if (layoutMode === LAYOUT_MODE_TYPES.AUTOMODE) {
            mediaQuery.addEventListener("change", syncResolvedMode);
        }

        return () => mediaQuery.removeEventListener("change", syncResolvedMode);
    }, [layoutMode]);

    const options = [
        { value: LAYOUT_MODE_TYPES.LIGHTMODE, icon: "bi-sun", label: t("Light") },
        { value: LAYOUT_MODE_TYPES.DARKMODE, icon: "bi-moon", label: t("Dark") },
        { value: LAYOUT_MODE_TYPES.AUTOMODE, icon: "bi-circle-half", label: t("System") },
    ];

    return (
        <React.Fragment>
        <Dropdown className="topbar-head-dropdown ms-1 header-item" align="start">
            <Dropdown.Toggle as='button' className="btn btn-icon btn-topbar btn-ghost-dark rounded-circle mode-layout arrow-none" aria-label={t("Change appearance")} title={`${t("Appearance")}: ${t(layoutMode === "auto" ? "System" : resolvedMode === "dark" ? "Dark" : "Light")}`}>
                <i className={`bi ${resolvedMode === "dark" ? "bi-moon-stars" : "bi-sun"} align-middle`}></i>
            </Dropdown.Toggle>                
            <Dropdown.Menu className="p-2 dropdown-menu-end modern-dropdown mode-menu" id="light-dark-mode">
                <div className="mode-menu__label">{t("Appearance")}</div>
                {options.map((option) => (
                    <Dropdown.Item
                        as="button"
                        type="button"
                        key={option.value}
                        data-mode={option.value}
                        active={layoutMode === option.value}
                        aria-pressed={layoutMode === option.value}
                        onClick={() => dispatch(changeLayoutMode(option.value))}
                    >
                        <i className={`bi ${option.icon} align-middle me-2`}></i>
                        <span>{option.label}</span>
                        {layoutMode === option.value && <i className="bi bi-check-lg mode-menu__check ms-auto" aria-hidden="true"></i>}
                    </Dropdown.Item>
                ))}
            </Dropdown.Menu>
        </Dropdown>
    </React.Fragment>
    
    )
}

export default LayoutModeDropdown;
